<template>
  <div>
    <div class="row">
      <template v-if="partner.type === 'natural'">
        <div class="col-md-4 offset-md-right-9">
          <div class="form-group">
            <select v-model="partner.gender"
                    class="form-control"
                    :class="{'is-invalid' : hasError('gender')}"
                    @mouseover="showInfo('gender')"
                    @mouseleave="hideInfo">
              <option v-for="gender in genders" :value="gender">
                {{ __(`forms.options.genders.${gender}`) }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group"
               @mouseover="showInfo('pre_title')"
               @mouseleave="hideInfo">
            <multiselect v-model="partner.tempPreTitle"
                         :options="localPreTitles"
                         :multiple="true"
                         track-by="input"
                         label="input"
                         :internal-search="false"
                         @search-change="searchPreTitleInput"
                         :placeholder="__('forms.placeholders.pre_title')">
            </multiselect>
            <span :class="{'error-area': hasError('title_prefix')}"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('title_prefix')"
                  @click="showInfo('title_prefix')"></span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input v-model="partner.first_name"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid' : hasError('first_name')}"
                   :placeholder="__('forms.placeholders.first_name')"
                   @click="showInfo('first_name')">
            <span v-if="hasError('first_name')" class="error-area"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('first_name')"></span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input v-model="partner.last_name"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid' : hasError('last_name')}"
                   :placeholder="__('forms.placeholders.last_name')"
                   @click="showInfo('last_name')">
            <span v-if="hasError('last_name')" class="error-area"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('last_name')"></span>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group"
               @mouseover="showInfo('post_title')"
               @mouseleave="hideInfo">
            <multiselect v-model="partner.tempPostTitle"
                         :options="localPostTitles"
                         :multiple="true"
                         track-by="input"
                         label="input"
                         :internal-search="false"
                         @search-change="searchPostTitleInput"
                         @click="showInfo('title_postfix')"
                         :placeholder="__('forms.placeholders.post_title')">
            </multiselect>
            <span :class="{'error-area': hasError('title_prefix')}"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('title_postfix')"
                  @click="showInfo('title_postfix')"></span>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <div class="position-relative">
              <input v-model="partner.birthdate"
                     type="text"
                     class="form-control has-icon"
                     :class="{'is-invalid' : hasError('birthdate')}"
                     :placeholder="__('forms.placeholders.birthdate')"
                     @click="showInfo('date_dmy')">
              <i class="icon icon-calendar"></i>
              <span
                  :class="{'error-area': hasError('birthdate')}"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('birthdate')"
                  @click="showInfo('date_dmy')"></span>
            </div>
          </div>
        </div>
        <div class="col-md-9">
          <div class="form-group select-wrapper">
            <label>
              <span class="text">{{ __('forms.placeholders.by_partner_type.natural.citizenship') }}</span>
              <select v-model="partner.country"
                      class="form-control"
                      :class="{'is-invalid' : hasError('country')}"
                      @mouseover="showInfo('country')"
                      @mouseleave="hideInfo">
                <option v-for="(country, code) in countries" :value="code">
                  {{ country }}
                </option>
              </select>
            </label>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-md-9">
          <div class="form-group">
            <input v-model="partner.first_name"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid' : hasError('first_name')}"
                   :placeholder="__('forms.placeholders.name')"
                   @click="showInfo('name')">
            <span v-if="hasError('first_name')" class="error-area"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('first_name')"></span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input v-model="partner.reg_number" type="text"
                   class="form-control"
                   :class="{'is-invalid' : hasError('reg_number')}"
                   :placeholder="__('forms.placeholders.reg_number')">
            <span v-if="hasError('reg_number')" class="error-area"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('reg_number')"></span>
          </div>
        </div>
      </template>
      <div class="col-md-9">
        <div class="form-group">
          <input v-model="partner.street" type="text"
                 class="form-control"
                 :class="{'is-invalid' : hasError('street')}"
                 :placeholder="__('forms.placeholders.street')"
                 @click="showInfo('street')">
          <span v-if="hasError('street')" class="error-area"
                data-toggle="tooltip" data-placement="bottom"
                :title="getError('street')"></span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <input v-model="partner.street_nr" type="text"
                 class="form-control"
                 :class="{'is-invalid' : hasError('street_nr')}"
                 :placeholder="__('forms.placeholders.street_nr')"
                 @click="showInfo('street_nr')">
          <span v-if="hasError('street_nr')" class="error-area"
                data-toggle="tooltip" data-placement="bottom"
                :title="getError('street_nr')"></span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <input v-model="partner.zip_code" type="text"
                 class="form-control"
                 :class="{'is-invalid' : hasError('zip_code')}"
                 :placeholder="__('forms.placeholders.zip_code')"
                 @click="showInfo('zip_code')">
          <span v-if="hasError('zip_code')" class="error-area"
                data-toggle="tooltip" data-placement="bottom"
                :title="getError('zip_code')"></span>
        </div>
      </div>
      <div class="col-md-9">
        <div class="form-group">
          <input v-model="partner.city" type="text"
                 class="form-control"
                 :class="{'is-invalid' : hasError('city')}"
                 :placeholder="__('forms.placeholders.city')"
                 @click="showInfo('city')">
          <span v-if="hasError('city')" class="error-area"
                data-toggle="tooltip" data-placement="bottom"
                :title="getError('city')"></span>
        </div>
      </div>
      <template v-if="partner.type === 'natural'">
        <div class="col-md-3">
          <div class="form-group">
            <input v-model="partner.phone" type="text"
                   class="form-control"
                   :class="{'is-invalid' : hasError('phone')}"
                   :placeholder="__('forms.placeholders.phone')"
                   @mouseover="showInfo('phone')"
                   @mouseleave="hideInfo">
            <span v-if="hasError('phone')" class="error-area"
                  data-toggle="tooltip" data-placement="bottom"
                  :title="getError('city')"></span>
          </div>
        </div>
        <div class="col-md-9">
          <div class="form-group select-wrapper">
            <label>
              <span class="text width-200px">{{ __('forms.placeholders.preferred_language') }}:</span>
              <select v-model="partner.language"
                      class="form-control partner-language"
                      :class="{'is-invalid' : hasError('language')}"
                      @mouseover="showInfo('language')"
                      @mouseleave="hideInfo">
                <option v-for="(language) in shareholderLanguages.austrian" :value="language">
                  {{ __(`project.shareholder_languages.version_1.${language}`) }}
                </option>
                <option value="" disabled="disabled">- - - - - - - - - - - - -</option>
                <option v-for="(language) in shareholderLanguages.other" :value="language">
                  {{ __(`project.shareholder_languages.version_1.${language}`) }}
                </option>
              </select>
            </label>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-md-12">
          <div class="form-group select-wrapper">
            <label>
              <span class="text width-140px">{{ __('forms.placeholders.by_partner_type.legal.citizenship') }}</span>
              <select v-model="partner.country"
                      class="form-control partner-country"
                      :class="{'is-invalid' : hasError('country')}"
                      @mouseover="showInfo('country')"
                      @mouseleave="hideInfo">
                <option v-for="(country, code) in countries" :value="code">
                  {{ country }}
                </option>
              </select>
            </label>
          </div>
        </div>
      </template>

      <!--            <div v-if="canHaveRepresentative" class="col-md-4">-->
      <!--                <div class="form-group mb-0">-->
      <!--                    <label>{{ __('forms.labels.represented_by') }}</label>-->
      <!--                    <select v-model="partner.representative_subtype"-->
      <!--                            class="form-control"-->
      <!--                            @mouseover="showInfo('represented_by')"-->
      <!--                            @mouseleave="hideInfo">-->
      <!--                        <template v-if="partner.type === 'natural'">-->
      <!--                            <option :value="null">{{ __('forms.options.representatives.nobody') }}</option>-->
      <!--                            <option disabled class="font-weight-bold">{{ __('forms.options.partner_types.natural') }}-->
      <!--                            </option>-->
      <!--                            <option-->
      <!--                                    v-for="type in representativeTypes.person.natural" :value="type">-->
      <!--                                {{ __(`forms.options.representatives.${type}`) }}-->
      <!--                            </option>-->
      <!--                            <option disabled class="font-weight-bold">{{ __('forms.options.partner_types.legal') }}-->
      <!--                            </option>-->
      <!--                            <option-->
      <!--                                    v-for="type in representativeTypes.person.legal" :value="type">-->
      <!--                                {{ __(`forms.options.representatives.${type}`) }}-->
      <!--                            </option>-->
      <!--                        </template>-->
      <!--                        <template v-else>-->
      <!--                            <option v-for="type in representativeTypes.company" :value="type">-->
      <!--                                {{ __(`forms.options.representatives.${type}`) }}-->
      <!--                            </option>-->
      <!--                        </template>-->
      <!--                    </select>-->
      <!--                    <span v-if="canRemoveRepresentative"-->
      <!--                          class="remove-representative"-->
      <!--                          @click="partner.representative_subtype = null">-->
      <!--                        <i class="icon icon-close-lg"></i>-->
      <!--                    </span>-->
      <!--                </div>-->
      <!--            </div>-->
    </div>
    <div v-if="partner.representative" class="representative mt-3">
      <partner-fields :partner="partner.representative"
                      :parent-type="partner.type"
                      :depth="depth + 1"
                      :filled-from-draft="filledFromDraft"
                      :validation-errors="hasError('representative') ? getError('representative') : {}"/>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue-bootstrap-datetimepicker';
import hasInfoHighlighterMixin from '../vue/mixins/has-info-highlighter';
import workerTitlesForVueFiles from '../vue/mixins/worker-titles-for-vue-files';
import {getters as validationGettersMixin} from '../vue/mixins/validation';
import dbOptionsMixin from '../vue/mixins/dp-options';
import Multiselect from '../components/multiselect/src/Multiselect';

export default {
  name: 'PartnerFields',
  mixins: [
    hasInfoHighlighterMixin,
    validationGettersMixin,
    dbOptionsMixin,
    workerTitlesForVueFiles,
  ],
  components: {
    DatePicker,
    Multiselect,
  },
  props: {
    depth: {
      type: Number,
      default: 0,
    },
    partner: {
      type: Object,
      default: () => {
      },
    },
    parentType: {
      type: String,
      default: null
    },
    filledFromDraft: {
      type: Boolean,
      default: false
    },
    validationErrors: {
      type: Object,
      default: () => {
      },
    }
  },
  data() {
    return {
      representativeTypes,
      countries,
      genders,
      shareholderLanguages,
      preTitles,
      postTitles,
      localPreTitles: preTitles,
      localPostTitles: postTitles,
      tempPreTitle: this.partner.tempPreTitle,
      tempPostTitle: this.partner.tempPostTitle,
    };
  },
  computed: {
    canHaveRepresentative() {
      return !this.parentType ||
          !(
              (this.parentType === 'natural' && this.partner.type === 'natural') ||
              (this.parentType === 'legal' && this.depth >= 2)
          );
    },
    canRemoveRepresentative() {
      return (this.partner.representative_subtype !== null) && (this.partner.type === 'natural');
    }
  },
  watch: {
    'partner.type': function (type) {
      if (!this.filledFromDraft) {
        this.$nextTick(() => {
          this.setRepresentative();
        });

        if (this.partner.type === 'legal') {
          this.partner.gender = 'female';
        }
      }
    },
    'partner.representative_subtype': function (subtype) {
      this.$nextTick(() => {
        if (this.partner.type === 'natural') {
          this.setRepresentativeBySubType(subtype);
        }
      });
    },
  },
  methods: {
    setRepresentative() {
      if (this.partner.type === 'legal') {
        this.partner = this.setNaturalRepresentativeData(this.partner);
      } else {
        this.partner.representative_type = null;
        this.partner.representative_subtype = null;
        this.partner.representative = null;
      }
    },
    setRepresentativeBySubType(subtype) {
      this.partner.representative_type = subtype ?
          (this.representativeTypes.person.natural.includes(subtype)
              ? 'natural' : 'legal') : null;
      this.partner.representative = null;

      if (this.partner.representative_type) {
        let representativeData = {
          type: this.partner.representative_type,
          subtype: subtype,
        };

        if (this.partner.representative_type === 'legal') {
          representativeData = this.setNaturalRepresentativeData(representativeData);
        }

        this.partner.representative = _.merge(this.getRepresentativeTemplate(), representativeData);
      }
    },
    setNaturalRepresentativeData(partner) {
      partner.representative_type = 'natural';
      partner.representative_subtype = this.representativeTypes.company[0];

      partner.representative = this.getRepresentativeTemplate();

      return partner;
    },
    getRepresentativeTemplate() {
      return {
        type: 'natural',
        subtype: this.representativeTypes.company[0],
        gender: 'male',
        language: defaults.shareholder_language,
        first_name: null,
        last_name: null,
        birthdate: null,
        street: null,
        street_nr: null,
        zip_code: null,
        city: null,
        country: 'AT',
        tempPreTitle: null,
        tempPostTitle: null,
        pre_title: null,
        pre_title_short: null,
        pre_title_long: null,
        post_title: null,
        post_title_short: null,
        post_title_long: null,
        auto_generate_titles: true,
        representative_type: null,
        representative_subtype: null,
        representative: null,
      };
    },
  }
}
</script>
